export default class areaModel {

    constructor ({ id, name, area_point, is_active, language, created_by_name }) {
        this.id = id;
        this.name_area = name;
        this.titik_area = area_point;
        this.language = language;
        this.created_by_name = created_by_name;
        this.status = is_active;
    }
}